/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable no-undef */
/* eslint-disable complexity */
import React, { Component, lazy, Suspense } from 'react';
import styles from './cropable.css';
import * as commonFun from './common';
import { toJS, transaction } from 'mobx';
import { mobxSet } from '@src/slide/infrastructure/module/independent/assert/get-set';
import {
    getCursorWithRotate,
} from '../../../../js/utils';
import {
    transform, getBaseIndexWithMode, calResize,
} from '@src/slide/domain/ui-model/element-modeles/property/text/utils/resize';
import Draggable from './draggable';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import LZImg from '../../../../../../../js/lzimg';
import ErrorBoundary from '../../../../../../frame/components/error-boundary';
import isLockAspect from '@editor/src/js/utils/lock-aspect';
import { SelectedEleMgrType } from '@src/slide/domain/selection/constant/select-element-type';
import { MODES } from '@src/slide/domain/ui-model/element-modeles/property/frame/frame.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import ResizeLogicPC from './resize-logic-pc';
import ImageQuickLookManager from '@src/slide/infrastructure/module/dependent/image/image-toolkit/image-quick-look-manager';
import { IFillRect } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import { IFlipInfo, ISizeInfo } from '@src/slide/application/service/edit-action-services/element-info';
import _has from 'lodash/has';
import _set from 'lodash/set';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { isGroupModel } from '@src/slide/domain/ui-model/elements/element-judge';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

const Resizable = lazy(() => import(/* webpackChunkName: "lazyComponents" */ './resizable'));
interface CropableProps {
    component: IPictureModel | IShapeModel;              // 关联model
    width: number;                 // 父控件的width
    height: number;                // 父控件的height
    rw: number;                    // 前景图width
    rh: number;                    // 前景图height
    pt: string;                    // 前景图的top
    pl: string;                    // 前景图的left
    pr: string;                    // 前景图的right
    pb: string;                    // 前景图的bottom
    src: string;                   // 前景图的src
    flip: object;                  // 父控件的flip
    scale: number;
    children: React.ReactNode;     // 子节点
    rotate: number;                // context的rotate
    type: string;                  // context的type
    relativeRotate: number;       // context的groupRelativeRotate
    relativeFlipH: number;
    relativeFlipV: number;
    getCropSize: () => void;
    getSize: () => ISizeInfo;
    getFlip: () => IFlipInfo;
    getOldSrcRect: () => IFillRect;
    isCroping: boolean;
}

interface CropableState {
    resizeMode: string | null;
}

class Cropable extends Component<CropableProps, CropableState> {
    static displayName = 'Cropable';

    private resizeLogicInstance: ResizeLogicPC;
    private sizeAtStartForImage: any;
    private flipAtStart: any;
    private changed: boolean;
    private sizeAtStart: any;
    private dragging: boolean;
    private startMousePosition: { x: any; y: any; };
    private startSize: ISizeInfo;
    private isExistGroup: boolean;
    private transformedRect: any;
    private baseIndex: number;

    public constructor(props, context) {
        super(props, context);

        this.state = {
            resizeMode: null,
        };
    }

    public render() {
        return (
            <div>
                { this.props.isCroping && this.renderCropResizeAndDrap() }
                { this.props.isCroping && this.renderCropImage() }
                { this.props.isCroping && this.renderCropImageMask() }
                { this.props.children }
                { this.props.isCroping && this.renderCropArea() }
            </div>
        );
    }

    private getSrcRect = () => {
        const srcRectOld = this.props.getOldSrcRect();
        const srcRect: IFillRect = {
            t: 0,
            b: 0,
            r: 0,
            l: 0,
        };
        if (srcRectOld) {
            if (srcRectOld.t) {
                srcRect.t = srcRectOld.t;
            } else {
                srcRect.t = 0;
            }
            if (srcRectOld.b) {
                srcRect.b = srcRectOld.b;
            } else {
                srcRect.b = 0;
            }
            if (srcRectOld.r) {
                srcRect.r = srcRectOld.r;
            } else {
                srcRect.r = 0;
            }
            if (srcRectOld.l) {
                srcRect.l = srcRectOld.l;
            } else {
                srcRect.l = 0;
            }
        }
        return srcRect;
    };

    private onResize = (e, originalSize, nextSize, mode) => {
        this.changed = true;

        const resizingHorizontally = mode !== MODES.TOP && mode !== MODES.BOTTOM;
        const resizingVertically = mode !== MODES.LEFT && mode !== MODES.RIGHT;

        const targetSize = {
            ...this.sizeAtStart,
            ...this.flipAtStart,
        };

        const srcRect = this.getSrcRect();

        const targetImageSize = {
            width: nextSize.width,
            height: nextSize.height,
        };

        this.handleOnResizeResizingHorizontally(resizingHorizontally, targetImageSize, nextSize, mode, srcRect);
        this.handleOnResizeResizingVertically(resizingVertically, targetImageSize, nextSize, mode, srcRect);

        this.runConstraints(this.sizeAtStart, targetSize, srcRect);
    };

    private handleOnResizeResizingVertically(resizingVertically, pTargetImageSize, nextSize, mode, pSrcRect) {
        const targetImageSize = pTargetImageSize;
        const srcRect = pSrcRect;
        if (resizingVertically) {
            targetImageSize.height = nextSize.height;
            if (nextSize.normalHeight < 0) {
                targetImageSize.height = 0;
            }
            const offset = targetImageSize.height - this.sizeAtStartForImage.height;

            if (mode === MODES.TOP_LEFT
                || mode === MODES.TOP
                || mode === MODES.TOP_RIGHT) {
                if (this.flipAtStart.flipV === 1) {
                    const pb = ((-this.sizeAtStartForImage.aBottom) - offset);
                    const pt = this.sizeAtStartForImage.aTop;

                    if (this.props.type === UIModelType.IMAGE) {
                        srcRect.b = -pb / (this.sizeAtStart.height + pt - pb);
                        srcRect.t = (pt * (1 - srcRect.b)) / (this.sizeAtStart.height + pt);
                    } else {
                        srcRect.b = -pb / this.sizeAtStart.height;
                        srcRect.t = pt / this.sizeAtStart.height;
                    }
                } else {
                    const pt = ((-this.sizeAtStartForImage.aTop) - offset);
                    const pb = this.sizeAtStartForImage.aBottom;

                    if (this.props.type === UIModelType.IMAGE) {
                        srcRect.t = -pt / (this.sizeAtStart.height + pb - pt);
                        srcRect.b = (pb * (1 - srcRect.t)) / (this.sizeAtStart.height + pb);
                    } else {
                        srcRect.t = -pt / this.sizeAtStart.height;
                        srcRect.b = pb / this.sizeAtStart.height;
                    }
                }
            } else if (this.flipAtStart.flipV === 1) {
                const pt = ((-this.sizeAtStartForImage.aTop) - offset);
                const pb = this.sizeAtStartForImage.aBottom;

                if (this.props.type === UIModelType.IMAGE) {
                    srcRect.t = -pt / (this.sizeAtStart.height + pb - pt);
                    srcRect.b = (pb * (1 - srcRect.t)) / (this.sizeAtStart.height + pb);
                } else {
                    srcRect.t = -pt / this.sizeAtStart.height;
                    srcRect.b = pb / this.sizeAtStart.height;
                }
            } else {
                const pb = ((-this.sizeAtStartForImage.aBottom) - offset);
                const pt = this.sizeAtStartForImage.aTop;

                if (this.props.type === UIModelType.IMAGE) {
                    srcRect.b = -pb / (this.sizeAtStart.height + pt - pb);
                    srcRect.t = (pt * (1 - srcRect.b)) / (this.sizeAtStart.height + pt);
                } else {
                    srcRect.b = -pb / this.sizeAtStart.height;
                    srcRect.t = pt / this.sizeAtStart.height;
                }
            }
        }
    }

    private handleOnResizeResizingHorizontally(resizingHorizontally, pTargetImageSize, nextSize, mode, pSrcRect) {
        const targetImageSize = pTargetImageSize;
        const srcRect = pSrcRect;
        if (resizingHorizontally) {
            targetImageSize.width = nextSize.width;
            if (nextSize.normalWidth < 0) {
                targetImageSize.width = 0;
            }
            const offset = targetImageSize.width - this.sizeAtStartForImage.width;

            if (mode === MODES.TOP_LEFT
                || mode === MODES.LEFT
                || mode === MODES.BOTTOM_LEFT) {
                if (this.flipAtStart.flipH === 1) {
                    const pr = ((-this.sizeAtStartForImage.aRight) - offset);
                    const pl = this.sizeAtStartForImage.aLeft;

                    if (this.props.type === UIModelType.IMAGE) {
                        srcRect.r = -pr / (this.sizeAtStart.width + pl - pr);
                        srcRect.l = (pl * (1 - srcRect.r)) / (this.sizeAtStart.width + pl);
                    } else {
                        srcRect.r = -pr / this.sizeAtStart.width;
                        srcRect.l = pl / this.sizeAtStart.width;
                    }
                } else {
                    const pl = ((-this.sizeAtStartForImage.aLeft) - offset);
                    const pr = this.sizeAtStartForImage.aRight;

                    if (this.props.type === UIModelType.IMAGE) {
                        srcRect.l = -pl / (this.sizeAtStart.width + pr - pl);
                        srcRect.r = (pr * (1 - srcRect.l)) / (this.sizeAtStart.width + pr);
                    } else {
                        srcRect.l = -pl / this.sizeAtStart.width;
                        srcRect.r = pr / this.sizeAtStart.width;
                    }
                }
            } else if (this.flipAtStart.flipH === 1) {
                const pl = ((-this.sizeAtStartForImage.aLeft) - offset);
                const pr = this.sizeAtStartForImage.aRight;

                if (this.props.type === UIModelType.IMAGE) {
                    srcRect.l = -pl / (this.sizeAtStart.width + pr - pl);
                    srcRect.r = (pr * (1 - srcRect.l)) / (this.sizeAtStart.width + pr);
                } else {
                    srcRect.l = -pl / this.sizeAtStart.width;
                    srcRect.r = pr / this.sizeAtStart.width;
                }
            } else {
                const pr = ((-this.sizeAtStartForImage.aRight) - offset);
                const pl = this.sizeAtStartForImage.aLeft;

                if (this.props.type === UIModelType.IMAGE) {
                    srcRect.r = -pr / (this.sizeAtStart.width + pl - pr);
                    srcRect.l = (pl * (1 - srcRect.r)) / (this.sizeAtStart.width + pl);
                } else {
                    srcRect.r = -pr / this.sizeAtStart.width;
                    srcRect.l = pl / this.sizeAtStart.width;
                }
            }
        }
    }

    private onResizeStart = (e, resizeMode) => {
        this.sizeAtStartForImage = this.props.getCropSize();
        this.sizeAtStart = this.props.getSize();
        this.flipAtStart = this.props.getFlip();
        this.changed = false;
        this.initResizeLogic(e, resizeMode);
    };

    private onResizeStop = () => {
        this.resizeLogicInstance.stopResize();
        if (this.changed) {
            this.persistSize();
        }
    };

    private initResizeLogic(e, mode) {
        const elementModel = this.props.component;
        this.resizeLogicInstance = new ResizeLogicPC({
            ...this.props,
            startSize: this.sizeAtStartForImage,
            startFlip: this.flipAtStart,
            onResize: this.onResize,
            modelIsLockAspect: Number(isLockAspect(elementModel.type, elementModel.props)),
            resizeMode: mode,
            isCroping: true,
        });
        this.resizeLogicInstance.startResize(e);
    }

    private getEventCoordinates = e => ({
        x: e.touches ? e.touches[0].clientX : e.clientX,
        y: e.touches ? e.touches[0].clientY : e.clientY,
    });

    private onDrag = (e, originalSize, nextSize) => {
        this.changed = true;

        const srcRect = this.getSrcRect();

        let offsetX = originalSize.left - nextSize.left;
        let offsetY = originalSize.top - nextSize.top;

        const angle = this.props.rotate * Math.PI / 180;
        const cosAngle = Math.cos(angle);
        const sinAngle = Math.sin(angle);
        const relativeX = (offsetX * cosAngle) + (offsetY * sinAngle);
        const relativeY = (offsetY * cosAngle) - (offsetX * sinAngle);
        offsetX = relativeX;
        offsetY = relativeY;

        if (this.flipAtStart.flipH === 1) {
            offsetX = -offsetX;
        }

        if (this.flipAtStart.flipV === 1) {
            offsetY = -offsetY;
        }
        const pl = this.sizeAtStartForImage.aLeft + offsetX;
        const pr = this.sizeAtStartForImage.aRight - offsetX;
        const pt = this.sizeAtStartForImage.aTop + offsetY;
        const pb = this.sizeAtStartForImage.aBottom - offsetY;

        if (this.props.type === UIModelType.IMAGE) {
            srcRect.l = pl / (this.sizeAtStart.width + pr + pl);
            srcRect.r = pr / (this.sizeAtStart.width + pr + pl);
            srcRect.t = pt / (this.sizeAtStart.height + pb + pt);
            srcRect.b = pb / (this.sizeAtStart.height + pb + pt);
        } else {
            srcRect.l = pl / this.sizeAtStart.width;
            srcRect.r = pr / this.sizeAtStart.width;
            srcRect.t = pt / this.sizeAtStart.height;
            srcRect.b = pb / this.sizeAtStart.height;
        }
        const targetSize = {
            ...this.sizeAtStart,
            ...this.flipAtStart,
        };

        this.runConstraints(this.sizeAtStart, targetSize, srcRect);
    };

    private onDragStart = () => {
        this.changed = false;
        this.dragging = true;
        this.sizeAtStartForImage = this.props.getCropSize();
        this.sizeAtStart = this.props.getSize();
        this.flipAtStart = this.props.getFlip();
    };

    private onDragStop = () => {
        this.dragging = false;
        if (this.changed) {
            this.persistSize();
        }
    };

    private handleMouseDown = (e, mode) => {
        if (e.nativeEvent.which === 1) {
            this.cropHandlerStart(e, mode);
        }
    };
    private cropHandlerStart = (e, resizeMode) => {
        this.changed = false;
        e.preventDefault();
        e.stopPropagation();
        this.startMousePosition = this.getEventCoordinates(e);
        this.sizeAtStart = this.props.getSize();
        this.sizeAtStartForImage = this.props.getCropSize();
        this.startSize = this.props.getSize();

        // /先把左上顶点置0，   然后再给还原
        this.sizeAtStart.left = 0;
        this.sizeAtStart.top = 0;

        this.flipAtStart = this.props.getFlip();
        document.addEventListener('mousemove', this.handleCropMouseMove);
        document.addEventListener('mouseup', this.cropHandlerStop);
        document.addEventListener('touchmove', this.handleCropMouseMove);
        document.addEventListener('touchend', this.cropHandlerStop);
        this.setState({ resizeMode });

        const {
            left, top, width, height,
        } = this.sizeAtStart;
        this.isExistGroup = (this.getSelectionService()
            ?.selectedElements.selectedArrayForType(SelectedEleMgrType.GROUP).length > 0);
        // 计算初始状态旋转后的rect
        this.transformedRect = transform({
            x: left,
            y: top,
            width,
            height,
        }, this.props.rotate);

        // 对角线点的索引即为缩放基点索引
        this.baseIndex = getBaseIndexWithMode(resizeMode, this.flipAtStart);
    };

    private cropHandlerStop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        document.removeEventListener('mousemove', this.handleCropMouseMove);
        document.removeEventListener('mouseup', this.cropHandlerStop);
        document.removeEventListener('touchmove', this.handleCropMouseMove);
        document.removeEventListener('touchend', this.cropHandlerStop);
        if (this.changed) {
            this.persistSize();
        }
        this.setState({ resizeMode: null });
    };

    private handleCropMouseMove = (e) => {
        this.changed = true;
        e.preventDefault();
        e.stopPropagation();

        if (!this.transformedRect) {
            return;
        }

        const nex = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
        const ney = e.type === 'touchmove' ? e.touches[0].clientY : e.clientY;

        const resizingHorizontally = this.state.resizeMode !== MODES.TOP
            && this.state.resizeMode !== MODES.BOTTOM;

        const resizingVertically = this.state.resizeMode !== MODES.LEFT
            && this.state.resizeMode !== MODES.RIGHT;

        const srcRect = this.getSrcRect();

        let offsetX = (nex - this.startMousePosition.x) / this.props.scale;
        let offsetY = (ney - this.startMousePosition.y) / this.props.scale;

        if (this.isExistGroup) {
            const angle = this.props.relativeRotate * Math.PI / 180;
            const sinAngle = Math.sin(angle);
            const cosAngle = Math.cos(angle);
            const tempY = (offsetY * cosAngle) - (offsetX * sinAngle);
            const tempX = (offsetX * cosAngle) + (offsetY * sinAngle);
            offsetX = tempX;
            offsetY = tempY;
            // 外层FlipV修正
            if (this.props.relativeFlipV === 1) {
                offsetY = -offsetY;
            }
            // 外层FlipH修正
            if (this.props.relativeFlipH === 1) {
                offsetX = -offsetX;
            }
        }

        const params = {
            transformedRect: this.transformedRect,
            flipAtStart: this.flipAtStart,
            sizeAtStart: this.sizeAtStart,
            baseIndex: this.baseIndex,
            type: this.props.type,
            rotate: this.props.rotate,
            offsetX,
            offsetY,
            e,
        };

        const { targetSize } = calResize(params);

        // /还原左上顶点位置
        targetSize.left = this.startSize.left + targetSize.left;
        targetSize.top = this.startSize.top + targetSize.top;

        if (this.flipAtStart.flipH !== targetSize.flipH || this.flipAtStart.flipV !== targetSize.flipV) {
            return;
        }

        this.handleMouseMoveResizingHorizontally(resizingHorizontally, targetSize, srcRect);
        this.handleMouseMoveResizingVertically(resizingVertically, targetSize, srcRect);

        this.runConstraints(this.startSize, targetSize, srcRect);
    };

    private handleMouseMoveResizingVertically(resizingVertically, targetSize, pSrcRect) {
        const srcRect = pSrcRect;
        if (resizingVertically) {
            const offset = targetSize.height - this.sizeAtStart.height;
            if (this.state.resizeMode === MODES.TOP_LEFT
                || this.state.resizeMode === MODES.TOP
                || this.state.resizeMode === MODES.TOP_RIGHT) {
                if (this.flipAtStart.flipV === 1) {
                    const pb = (-this.sizeAtStartForImage.aBottom) + offset;
                    if (this.props.type === UIModelType.IMAGE) {
                        srcRect.b = (-pb * (1 - srcRect.t)) / (targetSize.height - pb);
                    } else {
                        srcRect.b = -pb / targetSize.height;
                        srcRect.t = this.sizeAtStartForImage.aTop / targetSize.height;
                    }
                } else {
                    const pt = (-this.sizeAtStartForImage.aTop) + offset;
                    if (this.props.type === UIModelType.IMAGE) {
                        srcRect.t = (-pt * (1 - srcRect.b)) / (targetSize.height - pt);
                    } else {
                        srcRect.t = -pt / targetSize.height;
                        srcRect.b = this.sizeAtStartForImage.aBottom / targetSize.height;
                    }
                }
            } else if (this.flipAtStart.flipV === 1) {
                const pt = (-this.sizeAtStartForImage.aTop) + offset;
                if (this.props.type === UIModelType.IMAGE) {
                    srcRect.t = (-pt * (1 - srcRect.b)) / (targetSize.height - pt);
                } else {
                    srcRect.t = -pt / targetSize.height;
                    srcRect.b = this.sizeAtStartForImage.aBottom / targetSize.height;
                }
            } else {
                const pb = (-this.sizeAtStartForImage.aBottom) + offset;
                if (this.props.type === UIModelType.IMAGE) {
                    srcRect.b = (-pb * (1 - srcRect.t)) / (targetSize.height - pb);
                } else {
                    srcRect.b = -pb / targetSize.height;
                    srcRect.t = this.sizeAtStartForImage.aTop / targetSize.height;
                }
            }
        }
    }

    private handleMouseMoveResizingHorizontally(resizingHorizontally, targetSize, pSrcRect) {
        const srcRect = pSrcRect;
        if (resizingHorizontally) {
            const offset = targetSize.width - this.sizeAtStart.width;
            if (this.state.resizeMode === MODES.TOP_LEFT
                || this.state.resizeMode === MODES.LEFT
                || this.state.resizeMode === MODES.BOTTOM_LEFT) {
                if (this.flipAtStart.flipH === 1) {
                    const pr = (-this.sizeAtStartForImage.aRight) + offset;
                    if (this.props.type === UIModelType.IMAGE) {
                        srcRect.r = (-pr * (1 - srcRect.l)) / (targetSize.width - pr);
                    } else {
                        srcRect.r = -pr / targetSize.width;
                        srcRect.l = this.sizeAtStartForImage.aLeft / targetSize.width;
                    }
                } else {
                    const pl = (-this.sizeAtStartForImage.aLeft) + offset;
                    if (this.props.type === UIModelType.IMAGE) {
                        srcRect.l = (-pl * (1 - srcRect.r)) / (targetSize.width - pl);
                    } else {
                        srcRect.l = -pl / targetSize.width;
                        srcRect.r = this.sizeAtStartForImage.aRight / targetSize.width;
                    }
                }
            } else if (this.flipAtStart.flipH === 1) {
                const pl = (-this.sizeAtStartForImage.aLeft) + offset;
                if (this.props.type === UIModelType.IMAGE) {
                    srcRect.l = (-pl * (1 - srcRect.r)) / (targetSize.width - pl);
                } else {
                    srcRect.l = -pl / targetSize.width;
                    srcRect.r = this.sizeAtStartForImage.aRight / targetSize.width;
                }
            } else {
                const pr = (-this.sizeAtStartForImage.aRight) + offset;
                if (this.props.type === UIModelType.IMAGE) {
                    srcRect.r = (-pr * (1 - srcRect.l)) / (targetSize.width - pr);
                } else {
                    srcRect.r = -pr / targetSize.width;
                    srcRect.l = this.sizeAtStartForImage.aLeft / targetSize.width;
                }
            }
        }
    }

    private runConstraints = (originalSize, nextSize, srcRect) => {
        const offsetFrame = {
            left: (nextSize.left - originalSize.left),
            top: (nextSize.top - originalSize.top),
            width: (nextSize.width - originalSize.width),
            height: (nextSize.height - originalSize.height),
        };
        if (_has(nextSize, 'flipH')) {
            _set(offsetFrame, 'flipH', nextSize.flipH);
        }
        if (_has(nextSize, 'flipV')) {
            _set(offsetFrame, 'flipV', nextSize.flipV);
        }

        this.setState({
        });

        this.updateOperationFrame(offsetFrame, srcRect);
    };

    private updateOperationFrame = (offsetFrame, srcRect) => {
        transaction(() => {
            const selectedUIModelArr = this.getSelectionService()?.selectedElements.selectedArray;
            for (let i = 0; selectedUIModelArr && i < selectedUIModelArr.length; i++) {
                const selectedUIModel = selectedUIModelArr[i];
                if (offsetFrame === null) {
                    mobxSet(selectedUIModel, 'operationFrame', null);
                } else {
                    mobxSet(selectedUIModel, 'operationFrame', {
                        left: selectedUIModel.props.style.left + offsetFrame.left,
                        top: selectedUIModel.props.style.top + offsetFrame.top,
                        width: selectedUIModel.props.style.width + offsetFrame.width,
                        height: selectedUIModel.props.style.height + offsetFrame.height,
                    });
                    if (_has(offsetFrame, 'flipH')) {
                        mobxSet(selectedUIModel, 'operationFrame.flipH', offsetFrame.flipH);
                    }
                    if (_has(offsetFrame, 'flipV')) {
                        mobxSet(selectedUIModel, 'operationFrame.flipV', offsetFrame.flipV);
                    }
                }
                if (srcRect === null) {
                    mobxSet(selectedUIModel, 'srcRect', null);
                } else {
                    mobxSet(selectedUIModel, 'srcRect.b', srcRect.b);
                    mobxSet(selectedUIModel, 'srcRect.t', srcRect.t);
                    mobxSet(selectedUIModel, 'srcRect.r', srcRect.r);
                    mobxSet(selectedUIModel, 'srcRect.l', srcRect.l);
                }

                for (let j = 0; j < selectedUIModel.relatedUIModelRefs.length; j++) {
                    const connectorModel = selectedUIModel.relatedUIModelRefs[j];
                    const updateSytle = connectorModel.connectorCaculater.getUpdateStyle(offsetFrame);
                    connectorModel.updateModelStyle(updateSytle);
                }
            }
        });
    };

    private persistSize = () => {
        const selectedUiModels = this.getSelectionService()?.selectedElements.selectedArray as any;

        const updateModels: any = [];
        const propsArr: any = [];

        const toRemoveUIModels: any = [];
        const toRemovePropsArr: any = [];

        let { parent } = this.props.component;
        while (parent?.type === 'Group') {
            if (parent.parent?.type === 'Slide') {
                break;
            }
            parent = parent.parent;
        }

        if (isGroupModel(parent)) {
            const arr = parent?.getFrame().getAdjustedElementsAndProps();
            arr.forEach((item) => {
                propsArr.push(item.props);
                updateModels.push(item.uiModel);
            });
        }

        function notExistLogic(exist, curItem, srcRect) {
            if (!exist) {
                const props = {
                    style: curItem.operationFrame,
                };

                if (this.props.type === UIModelType.IMAGE) {
                    props.style.srcRect = srcRect;
                } else {
                    const stretch = { fillRect: srcRect };
                    const image: any = { stretch };
                    const { src } = this.props.component.props.style.fillBackground.image;
                    image.src = ImageQuickLookManager.getInstance().getResourceByUrl(src)
                        ?.getCdnUrl() || src;
                    const fillBackground = { image };
                    props.style.fillBackground = fillBackground;
                    if (this.props.component.props.style.fillBackground.image.stretch) {
                        this.props.component.props.style.fillBackground.image.stretch.srcRect = null;
                    }
                    this.props.component.props.srcRect = null;
                }
                props.style.rotate = this.props.rotate;
                props.style.flipH = _has(curItem, 'operationFrame.flipH') ? curItem.operationFrame.flipH : curItem.props.style.flipH;
                props.style.flipV = _has(curItem, 'operationFrame.flipV') ? curItem.operationFrame.flipV : curItem.props.style.flipV;

                updateModels.push(curItem);
                propsArr.push(props);
            }
        }

        selectedUiModels?.map((curItem) => {
            let srcRect: any = null;
            if (!curItem.srcRect) {
                srcRect = {
                    b: 0,
                    r: 0,
                    t: 0,
                    l: 0,
                };
            } else {
                srcRect = {
                    b: curItem.srcRect.b,
                    r: curItem.srcRect.r,
                    t: curItem.srcRect.t,
                    l: curItem.srcRect.l,
                };
            }

            let exist = false;
            for (let i = 0; i < updateModels.length; i++) {
                if (updateModels[i] === curItem) {
                    exist = true;

                    if (this.props.type === UIModelType.IMAGE) {
                        propsArr[i].style.srcRect = srcRect;
                    } else {
                        const stretch = { fillRect: srcRect };
                        const image: any = { stretch };
                        image.src = this.props.component.props.style.fillBackground?.image?.src;
                        const fillBackground = { image };
                        propsArr[i].style.fillBackground = fillBackground;
                        if (this.props.component.props.style.fillBackground?.image?.stretch) {
                            // @ts-ignore
                            this.props.component.props.style.fillBackground.image.stretch.srcRect = null;
                        }
                        // @ts-ignore
                        this.props.component.props.srcRect = null;
                    }
                    propsArr[i].style.rotate = this.props.rotate;
                    propsArr[i].style.flipH = _has(curItem, 'operationFrame.flipH') ? curItem.operationFrame?.flipH : curItem.props.style.flipH;
                    propsArr[i].style.flipV = _has(curItem, 'operationFrame.flipV') ? curItem.operationFrame?.flipV : curItem.props.style.flipV;
                    break;
                }
            }

            notExistLogic.call(this, exist, curItem, srcRect);

            // 当不为图片的元素裁剪时，填充方式由平铺改为充满
            if (curItem.type !== UIModelType.IMAGE && curItem.props.style.fillBackground
                && this.props.component.props.style?.fillBackground?.image?.tile) {
                toRemovePropsArr.push({
                    style: {
                        fillBackground: {
                            image: {
                                tile: null,
                            },
                        },
                    },
                });
                toRemoveUIModels.push(curItem);
            }
        });
        for (let i = 0; i < selectedUiModels?.length; i++) {
            const selectedUIModel = selectedUiModels[i];
            for (let j = 0; j < selectedUIModel.relatedUIModelRefs.length; j++) {
                const relatedUIModel = selectedUIModel.relatedUIModelRefs[j];
                // console.log('operationFrame ', relatedUIModel.operationFrame);
                if (relatedUIModel.type === UIModelType.CONNECTOR) {
                    updateModels.push(relatedUIModel);
                    propsArr.push({
                        style: {
                            ...relatedUIModel.operationFrame,
                            bgLine: relatedUIModel.props.style.bgLine,
                            controlValues: toJS(relatedUIModel.props.style.controlValues),
                        },
                    });
                }
            }
        }
        if (toRemoveUIModels.length > 0) {
            for (let i = 0; i < updateModels.length; i++) { // 补齐前面的空对象
                toRemovePropsArr.unshift(undefined);
            }
            for (let i = 0; i < toRemoveUIModels.length; i++) {
                propsArr.push(null);
            }
            this.getSelectionService()?.currentSlide?.updateAndRemovePropsForElements(
                propsArr,
                toRemovePropsArr,
                updateModels.concat(toRemoveUIModels),
            );
        } else {
            this.getSelectionService()?.currentSlide?.updateElementsProps(propsArr, updateModels);
        }

        if (isGroupModel(parent)) {
            if (selectedUiModels && selectedUiModels.length > 0) {
                (parent).getFrame().clearTempInfosWithElement(selectedUiModels[0]);
            }
        }
        this.updateOperationFrame(null, null);
    };

    private getSelectionService() {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .viewableServiceLayer?.selectionService;
    }

    /* 绘制裁剪时的，图层的resize drap元素 */
    private renderCropResizeAndDrap = () => (
        <div
            style={{
                width: this.props.rw,
                height: this.props.rh,
                position: 'absolute',
                top: this.props.pt,
                left: this.props.pl,
                right: this.props.pr,
                bottom: this.props.pb,
            }}
            onContextMenu={(e) => {
                e.stopPropagation();
                e.preventDefault();
            }}
            onMouseDown={(event) => {
                event.stopPropagation();
                event.preventDefault();
            }}
        >
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    transform: commonFun.transformOfFlip(this.props.flip),
                }}
            >
                <React.Fragment>
                    <ErrorBoundary>
                        <Suspense fallback={<div></div>}>
                            <Resizable
                                onResizeStart={this.onResizeStart}
                                onResizeStop={this.onResizeStop}
                                resizeHorizontal={true && !this.dragging}
                                resizeVertical={true && !this.dragging}
                                scale={this.props.scale}
                                rotate={this.props.rotate}
                                relativeRotate={this.props.relativeRotate}
                                relativeFlipH={this.props.relativeFlipH}
                                relativeFlipV={this.props.relativeFlipV}
                            />
                        </Suspense>
                    </ErrorBoundary>


                    <ErrorBoundary>
                        <Suspense fallback={<div></div>}>
                            <Draggable
                                getSize={this.props.getCropSize}
                                onDrag={this.onDrag}
                                onDragStart={this.onDragStart}
                                onDragStop={this.onDragStop}
                                draggable={true}
                                scale={this.props.scale}
                                relativeRotate={this.props.relativeRotate}
                                relativeFlipH={this.props.relativeFlipH}
                                relativeFlipV={this.props.relativeFlipV}
                                pointerEvents={'auto'}
                            >
                                <div className={styles.resizerImage} />

                            </Draggable>
                        </Suspense>
                    </ErrorBoundary>
                </React.Fragment>
            </div>
        </div>
    );

    /* 绘制裁剪时的，图层的image元素 */
    private renderCropImage = () => (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
            style={{
                position: 'absolute',
                pointerEvents: 'none',
                width: this.props.rw,
                height: this.props.rh,
                top: this.props.pt,
                left: this.props.pl,
                right: this.props.pr,
                bottom: this.props.pb,
                opacity: '0.5',
                // transform: commonFun.transformOfFlip(this.props.flip)
            }}
        >
            <LZImg syncLoad={true} xlinkHref={this.props.src} width={this.props.rw} height={this.props.rh} transform="matrix(1,0,0,1,0,0)" preserveAspectRatio="none" x={0} y={0} />
        </svg>
    );

    /* 绘制裁剪时的，图层的image mask元素 */
    private renderCropImageMask = () => (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
            style={{
                backgroundColor: 'black',
                pointerEvents: 'none',
                position: 'absolute',
                width: this.props.rw,
                height: this.props.rh,
                top: this.props.pt,
                left: this.props.pl,
                right: this.props.pr,
                bottom: this.props.pb,
                opacity: '0.5',
                // transform: commonFun.transformOfFlip(this.props.flip)
            }}
        />
    );

    /* 绘制裁剪时的，外框resize元素 */
    private renderCropArea = () => {
        const that = this;
        const scale = 1 / this.props.scale;
        let hh: any = Math.max(1 / this.props.scale, 1);
        hh = `${hh}px`;
        const margin = `${-11 * scale}px`;
        const wh = `${22 * scale}px`;
        const short = `${4 * scale}px`;
        const long = `${18 * scale}px`;

        const rotate = (this.props.rotate + this.props.relativeRotate) % 360;

        return (
            <div className={styles.cropArea}
                style={{
                    transform: commonFun.transformOfFlip(this.props.flip),
                }}
                onContextMenu={(e) => {
                    e.stopPropagation(); e.preventDefault();
                }}
            >
                <div className="crop-handlers">
                    <div className={`${styles.cropHandlerBorder} ${styles.cropHandlerBorderHorizontal}`} style={{
                        top: '33%', left: 0, width: this.props.width, height: hh,
                    }} />
                    <div className={`${styles.cropHandlerBorder} ${styles.cropHandlerBorderHorizontal}`} style={{
                        bottom: '33%', right: 0, width: this.props.width, height: hh,
                    }} />
                    <div className={`${styles.cropHandlerBorder} ${styles.cropHandlerBorderVerticle}`} style={{
                        top: 0, left: '33%', width: hh, height: this.props.height,
                    }} />
                    <div className={`${styles.cropHandlerBorder} ${styles.cropHandlerBorderVerticle}`} style={{
                        bottom: 0, right: '33%', width: hh, height: this.props.height,
                    }} />
                    <div className={styles.cropHandler}
                        style={{
                            cursor: getCursorWithRotate(
                                rotate,
                                { cornerTopLeft: true },
                                this.props.relativeFlipH,
                                this.props.relativeFlipV,
                            ),
                            width: wh,
                            height: wh,
                        }}
                        key={MODES.TOP_LEFT} onMouseDown={(function (e) {
                            that.handleMouseDown(e, MODES.TOP_LEFT);
                        })}>
                        <div className={styles.cropInnerHandler}
                            style={{ width: long, height: short, cursor: getCursorWithRotate(
                                rotate,
                                { cornerTopLeft: true },
                                this.props.relativeFlipH,
                                this.props.relativeFlipV,
                            ) }}
                        />
                        <div className={styles.cropInnerHandler}
                            style={{ width: short, height: long, cursor: getCursorWithRotate(
                                rotate,
                                { cornerTopLeft: true },
                                this.props.relativeFlipH,
                                this.props.relativeFlipV,
                            ) }}
                        />
                    </div>
                    <div className={styles.cropHandler} style={{
                        left: '50%', marginLeft: margin, cursor: getCursorWithRotate(rotate, { alignTop: true }, this.props.relativeFlipH, this.props.relativeFlipV), width: wh, height: wh,
                    }}
                    key={MODES.TOP} onMouseDown={(function (e) {
                        that.handleMouseDown(e, MODES.TOP);
                    })}>
                        <div className={styles.cropInnerHandler}
                            style={{ width: long, height: short, cursor: getCursorWithRotate(
                                rotate,
                                { alignTop: true },
                                this.props.relativeFlipH,
                                this.props.relativeFlipV,
                            ) }}
                        />
                    </div>
                    <div className={styles.cropHandler} style={{
                        right: '0px', cursor: getCursorWithRotate(rotate, { cornerTopRight: true }, this.props.relativeFlipH, this.props.relativeFlipV), width: wh, height: wh,
                    }}
                    key={MODES.TOP_RIGHT} onMouseDown={(function (e) {
                        that.handleMouseDown(e, MODES.TOP_RIGHT);
                    })}>
                        <div className={styles.cropInnerHandler} style={{
                            width: long, height: short, right: '0px', top: '0px', cursor: getCursorWithRotate(rotate, { cornerTopRight: true }, this.props.relativeFlipH, this.props.relativeFlipV),
                        }}/>
                        <div className={styles.cropInnerHandler} style={{
                            width: short, height: long, top: '0px', right: '0px', cursor: getCursorWithRotate(rotate, { cornerTopRight: true }, this.props.relativeFlipH, this.props.relativeFlipV),
                        }}/>
                    </div>
                    <div className={styles.cropHandler} style={{
                        left: '0px', top: '50%', marginTop: margin, cursor: getCursorWithRotate(rotate, { alignLeft: true }, this.props.relativeFlipH, this.props.relativeFlipV), width: wh, height: wh,
                    }}
                    key={MODES.LEFT} onMouseDown={(function (e) {
                        that.handleMouseDown(e, MODES.LEFT);
                    })}>
                        <div className={styles.cropInnerHandler} style={{
                            width: short, height: long, top: '0px', left: '0px', cursor: getCursorWithRotate(rotate, { alignLeft: true }, this.props.relativeFlipH, this.props.relativeFlipV),
                        }}/>
                    </div>
                    <div className={styles.cropHandler} style={{
                        right: '0px', top: '50%', marginTop: margin, cursor: getCursorWithRotate(rotate, { alignRight: true }, this.props.relativeFlipH, this.props.relativeFlipV), width: wh, height: wh,
                    }}
                    key={MODES.RIGHT} onMouseDown={(function (e) {
                        that.handleMouseDown(e, MODES.RIGHT);
                    })}>
                        <div className={styles.cropInnerHandler} style={{
                            width: short, height: long, top: '0px', right: '0px', cursor: getCursorWithRotate(rotate, { alignRight: true }, this.props.relativeFlipH, this.props.relativeFlipV),
                        }}/>
                    </div>
                    <div className={styles.cropHandler} style={{
                        bottom: '0px', left: '0px', cursor: getCursorWithRotate(rotate, { cornerBottomLeft: true }, this.props.relativeFlipH, this.props.relativeFlipV), width: wh, height: wh,
                    }}
                    key={MODES.BOTTOM_LEFT} onMouseDown={(function (e) {
                        that.handleMouseDown(e, MODES.BOTTOM_LEFT);
                    })}>
                        <div className={styles.cropInnerHandler} style={{
                            width: long, height: short, bottom: '0px', left: '0px', cursor: getCursorWithRotate(rotate, { cornerBottomLeft: true }, this.props.relativeFlipH, this.props.relativeFlipV),
                        }}/>
                        <div className={styles.cropInnerHandler} style={{
                            width: short, height: long, bottom: '0px', left: '0px', cursor: getCursorWithRotate(rotate, { cornerBottomLeft: true }, this.props.relativeFlipH, this.props.relativeFlipV),
                        }}/>
                    </div>
                    <div className={styles.cropHandler} style={{
                        bottom: '0px', right: '0px', cursor: getCursorWithRotate(rotate, { cornerBottomRight: true }, this.props.relativeFlipH, this.props.relativeFlipV), width: wh, height: wh,
                    }}
                    key={MODES.BOTTOM_RIGHT} onMouseDown={(function (e) {
                        that.handleMouseDown(e, MODES.BOTTOM_RIGHT);
                    })}>
                        <div className={styles.cropInnerHandler} style={{
                            width: long, height: short, bottom: '0px', right: '0px', cursor: getCursorWithRotate(rotate, { cornerBottomRight: true }, this.props.relativeFlipH, this.props.relativeFlipV),
                        }}/>
                        <div className={styles.cropInnerHandler} style={{
                            width: short, height: long, bottom: '0px', right: '0px', cursor: getCursorWithRotate(rotate, { cornerBottomRight: true }, this.props.relativeFlipH, this.props.relativeFlipV),
                        }}/>
                    </div>
                    <div className={styles.cropHandler} style={{
                        bottom: '0px', left: '50%', marginLeft: margin, cursor: getCursorWithRotate(rotate, { alignBottom: true }, this.props.relativeFlipH, this.props.relativeFlipV), width: wh, height: wh,
                    }}
                    key={MODES.BOTTOM} onMouseDown={(function (e) {
                        that.handleMouseDown(e, MODES.BOTTOM);
                    })}>
                        <div className={styles.cropInnerHandler} style={{
                            width: long, height: short, bottom: '0px', cursor: getCursorWithRotate(rotate, { alignBottom: true }, this.props.relativeFlipH, this.props.relativeFlipV),
                        }}/>
                    </div>
                </div>
            </div>
        );
    };
}

export default Cropable;
